import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { getTranslationByPartnerAccess } from '../../../helpers/getTranslationByPartnerAccess'

import { ExecutiveSummaryEditMode } from './components/executiveSummaryEditMode/ExecutiveSummaryEditMode'
import { ExecutiveSummaryReadMode } from './components/executiveSummaryReadMode/ExecutiveSummaryReadMode'

interface IExecutiveSummaryProps {
  executiveSummary: Nullable<string>
  isRetail?: boolean
  isDistributor?: boolean
}

export const ExecutiveSummary: FC<IExecutiveSummaryProps> = ({
  isDistributor,
  isRetail,
  executiveSummary,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div>
      <FieldLabel
        labelTranslation={getTranslationByPartnerAccess('partnerbasicinfo-executive-summary', {
          isRetail,
          isDistributor,
        })}
      />
      {!isEditMode && <ExecutiveSummaryReadMode executiveSummary={executiveSummary} />}
      {isEditMode && <ExecutiveSummaryEditMode executiveSummary={executiveSummary} />}
    </div>
  )
}
